import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useRequireUserAndCompany } from '../hooks';

export function RequireUserAndCompany({ children, }) {
  const {
    isBlocked,
    location,
    redirectTo,
  } = useRequireUserAndCompany();

  if (isBlocked) {
    return <Navigate to={redirectTo} state={{ from: location, }} replace />;
  }

  return children;
}

export default RequireUserAndCompany;

RequireUserAndCompany.propTypes = {
  children: PropTypes.node.isRequired,
};
